import { cn } from '@utils';
import { isPriceValid } from '../util';
import { CartItemDetails } from './components/cart-item-details';
import { CartItemDiscounts } from './components/cart-item-discounts';
import { CartItemSummary } from './components/cart-item-summary';
import type { CartItemProps } from './types';

export const CartItem = ({
	item,
	isLoading,
	currency,
	disableDiscount,
	disableDelete = false,
	disableQuantityChange = false,
	isChild = false,
	onRemoveDiscount,
	onQuantityChange,
	onDeleteItem,
	onDiscountItem,
	cartItemDescriptionLabel,
	className,
}: CartItemProps) => {
	const hasDiscounts = !!item.discounts?.length;
	const hasPrice = isPriceValid(item.price);

	return (
		<div className={cn('grid min-w-32 max-w-full grow grid-cols-1 gap-y-2', className)} data-testid="cart-item">
			<CartItemDetails
				item={item}
				isChild={isChild}
				disableDelete={disableDelete}
				onDeleteItem={onDeleteItem}
				isLoading={isLoading}
				disableDiscount={disableDiscount}
				onDiscountItem={onDiscountItem}
				currency={currency}
				cartItemDescriptionLabel={cartItemDescriptionLabel}
			/>
			{hasDiscounts && (
				<CartItemDiscounts item={item} onRemoveDiscount={onRemoveDiscount} isLoading={isLoading} currency={currency} />
			)}
			{hasPrice && (
				<CartItemSummary
					item={item}
					disableQuantityChange={disableQuantityChange}
					onQuantityChange={onQuantityChange}
					isLoading={isLoading}
					currency={currency}
				/>
			)}
		</div>
	);
};
